import React, { useEffect, useState } from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { Paper, Box, Typography, Stack, Divider } from '@mui/material';
import { TrendingUp } from '@mui/icons-material';

/**
 * A chart component to visualize average score growth over cycles using a bar chart.
 * @param {object} props - The component props.
 * @param {Array<object>} props.data - An array of objects containing cycle data.
 */
const CycleGrowthBar = ({ data }) => {


    console.log(data);
    const chartSetting = {
        height: 320,
        slotProps: {
        bar: {
            clipPath: `inset(0px round 4px 4px 0px 0px)`,
        },
        },
    };
  const [series, setSeries] = useState([])
  const [xLabels, setXLabels] = useState([])

  useEffect(() => {
    if (data) {
        const { series, xLabels} = parseData();
        setSeries(series)
        setXLabels(xLabels)
    }
  }, [data])

  const parseData = () => {
// Process data to group by location and program
    const groupedData = data.reduce((acc, current) => {
        const key = `${current.location_id}-${current.program_id}`;
        if (!acc[key]) {
            acc[key] = {
                id: key,
                label: `${current.location_name} - ${current.program_name}`,
                scoresByCycle: {},
            };
        }
        acc[key].scoresByCycle[current.cycle] = current.average_score;
        return acc;
    }, {});

    // Get a sorted list of unique cycles
    const xLabels = [...new Set(data.map(item => item.cycle))].sort((a, b) => a - b).map(cycle => `Cycle ${cycle}`);

    // Create a series for each program/location
    const series = Object.values(groupedData).map(group => ({
        data: xLabels.map(label => {
            const cycle = parseInt(label.replace('Cycle ', ''));
            return group.scoresByCycle[cycle] || 0; // Use 0 if no data for a cycle
        }),
        label: group.label,
    }));
    return { series, xLabels}
  }

    return (
            <Box sx={{p: 2}}>
                <Box sx={{ mb: 1 }}>
                    <Stack direction={"row"} spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                    <Box >
                    <Typography variant="h6" fontWeight="bold">
                        Cycle growth
                    </Typography>
                    <Typography variant="body2" color="text.secondary" >
                        Growth average by cycle
                    </Typography>
                    </Box>
                </Stack>
                </Box>
                
                <Divider/>
                <BarChart
                    xAxis={[{ scaleType: 'band', data: xLabels, label: 'Cycle' }]}
                    yAxis={[{ label: 'Average Score' }]}
                    series={series}
                    slotProps={{
                        legend: {
                            direction: 'row',
                            position: { vertical: 'bottom', horizontal: 'middle' },
                        },
                    }}
                    margin={{ top: 65, right: 20, left: 40, bottom: 50 }}
                    {...chartSetting}
                />
            </Box>
    );
};

export default CycleGrowthBar;